var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 791,
    height: 731,
    viewBox: "0 0 791 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step_four 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "step_four 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_contract_uy56 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_docs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.9133 58.3399C35.2103 58.3544 23.0318 63.407 14.0494 72.3894C5.06708 81.3717 0.0144484 93.5503 0 106.253V658.243C0.0145729 670.946 5.06727 683.124 14.0496 692.107C23.032 701.089 35.2104 706.141 47.9133 706.156H452.838C465.541 706.141 477.719 701.089 486.701 692.106C495.684 683.124 500.736 670.946 500.751 658.243V106.253C500.736 93.5503 495.684 81.3719 486.701 72.3895C477.719 63.4072 465.541 58.3545 452.838 58.3399H47.9133Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M475.835 92.3715H24.916V672.124H475.835V92.3715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M416.887 196.289H83.8636V218.167H416.887V196.289Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M416.887 254.629H83.8636V276.507H416.887V254.629Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M416.887 312.969H83.8636V334.847H416.887V312.969Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M416.887 371.309H83.8636V393.187H416.887V371.309Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M416.887 429.649H83.8636V451.526H416.887V429.649Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M416.887 487.989H83.8636V509.866H416.887V487.989Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M416.887 546.329H83.8636V568.206H416.887V546.329Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M236.112 629.965C242.681 625.469 249.434 620.793 257.235 618.749C264.354 616.884 272.527 617.378 278.157 622.59C282.701 626.796 284.619 633.261 281.253 638.794C280.531 640.057 279.549 641.152 278.373 642.007C277.197 642.863 275.854 643.46 274.43 643.758C273.055 643.94 271.657 643.77 270.365 643.266C269.073 642.761 267.93 641.937 267.042 640.872C265.276 638.921 264.22 636.039 265.158 633.468C266.145 630.764 268.783 629.111 271.374 628.188C274.39 627.233 277.497 626.591 280.644 626.273L293.537 624.508L346.306 617.284L405.071 609.239C405.536 609.108 405.93 608.799 406.168 608.379C406.406 607.96 406.47 607.463 406.344 606.997C406.206 606.537 405.895 606.149 405.478 605.912C405.06 605.675 404.568 605.607 404.102 605.724L287.171 621.731C282.941 622.31 278.652 622.725 274.467 623.575C271.172 624.108 268.048 625.406 265.345 627.364C259.743 631.799 260.143 639.643 265.298 644.282C270.516 648.979 278.082 648.17 282.661 642.983C284.976 640.358 286.35 637.036 286.567 633.542C286.783 630.049 285.829 626.582 283.855 623.692C278.856 616.155 269.748 613.259 261.045 614.328C250.979 615.564 242.446 621.222 234.271 626.816C232.347 628.134 234.168 631.295 236.112 629.965Z",
    fill: "#FF00CF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M421.575 55.6109L91.3511 116.043L169.049 540.616L499.273 480.184L421.575 55.6109Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M392.333 139.614L148.448 184.245L151.38 200.267L395.265 155.635L392.333 139.614Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M400.151 182.338L156.266 226.97L159.198 242.991L403.083 198.36L400.151 182.338Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M407.97 225.063L164.085 269.694L167.017 285.716L410.902 241.084L407.97 225.063Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M415.789 267.787L171.904 312.419L174.836 328.44L418.721 283.809L415.789 267.787Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M423.603 310.512L179.719 355.142L182.651 371.164L426.535 326.533L423.603 310.512Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M431.426 353.236L187.541 397.867L190.473 413.889L434.358 369.257L431.426 353.236Z",
    fill: "#3700CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M439.245 395.96L195.36 440.592L198.292 456.613L442.177 411.982L439.245 395.96Z",
    fill: "#3700CF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M333.866 30.3854H294.13V22.2507C294.13 16.3494 291.786 10.6899 287.613 6.51707C283.44 2.34426 277.781 0 271.88 0H228.871C222.97 5.30433e-06 217.31 2.34427 213.138 6.51708C208.965 10.6899 206.62 16.3494 206.62 22.2507V30.3854H166.885C163.963 30.3854 161.07 30.9609 158.37 32.0791C155.67 33.1973 153.218 34.8363 151.151 36.9024C149.085 38.9686 147.446 41.4215 146.328 44.1211C145.21 46.8206 144.634 49.714 144.634 52.636V114.249H356.116V52.636C356.116 49.714 355.541 46.8206 354.423 44.1211C353.304 41.4215 351.666 38.9686 349.599 36.9024C347.533 34.8363 345.08 33.1973 342.381 32.0791C339.681 30.9609 336.788 30.3854 333.866 30.3854Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sign_client"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M655.312 520.062L561.874 537.161L583.859 657.296L677.297 640.197L655.312 520.062Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M647.038 543.831L578.03 556.46L578.86 560.993L647.868 548.364L647.038 543.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M649.251 555.92L580.242 568.549L581.072 573.082L650.08 560.453L649.251 555.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M651.463 568.009L582.455 580.638L583.284 585.171L652.292 572.542L651.463 568.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M653.675 580.098L584.667 592.727L585.496 597.26L654.505 584.631L653.675 580.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M655.887 592.187L586.879 604.816L587.709 609.349L656.717 596.72L655.887 592.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M658.1 604.276L589.092 616.905L589.921 621.438L658.929 608.809L658.1 604.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M660.312 616.365L591.304 628.994L592.133 633.527L661.142 620.898L660.312 616.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M646.406 494.837L647.622 506.991C647.622 506.991 640.329 533.73 656.13 533.73C671.93 533.73 659.776 506.991 659.776 506.991L660.991 497.267L646.406 494.837Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M756.802 454.344L751.225 465.211C751.225 465.211 730.586 483.709 743.856 492.286C757.125 500.863 761.433 471.809 761.433 471.809L767.731 464.302L756.802 454.344Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M665.853 505.775L682.869 621.24L691.377 703.888C691.377 703.888 698.669 722.119 722.977 706.319L719.331 658.917L716.9 616.378C716.9 616.378 714.469 575.054 712.039 567.761C709.608 560.469 713.254 536.161 713.254 536.161L722.977 496.052L665.853 505.775Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M693.807 701.457L684.084 712.396C684.084 712.396 669.499 707.534 665.853 717.257C662.207 726.981 693.807 729.411 693.807 729.411C693.807 729.411 726.624 731.842 726.624 729.411C726.624 726.981 725.744 708.39 721.322 707.354C716.9 706.319 693.807 701.457 693.807 701.457Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M712.039 499.698L729.054 621.24L737.562 703.888C737.562 703.888 744.855 722.119 769.163 706.319L765.517 658.917L763.086 616.378C763.086 616.378 760.655 575.054 758.224 567.761C755.793 560.469 759.44 536.161 759.44 536.161L757.009 491.19L712.039 499.698Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M739.993 701.457L730.27 712.396C730.27 712.396 715.685 707.534 712.039 717.257C708.392 726.981 739.993 729.411 739.993 729.411C739.993 729.411 772.809 731.842 772.809 729.411C772.809 726.981 771.93 708.39 767.508 707.354C763.086 706.319 739.993 701.457 739.993 701.457Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M675.576 307.663C689.673 307.663 701.1 296.235 701.1 282.139C701.1 268.043 689.673 256.615 675.576 256.615C661.48 256.615 650.052 268.043 650.052 282.139C650.052 296.235 661.48 307.663 675.576 307.663Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M694.415 293.685L705.354 311.917L677.399 324.071L673.753 302.193L694.415 293.685Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M708.392 310.094C708.392 310.094 682.869 307.663 673.145 323.463L649.156 341.695C647.213 343.172 645.696 345.136 644.757 347.388C643.819 349.64 643.494 352.101 643.814 354.52L664.637 511.852L695.023 510.637L744.855 500.914L759.44 497.267L752.147 432.85C752.147 432.85 743.639 407.327 753.363 390.311L748.501 330.756L714.469 317.386L708.392 310.094Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M651.268 346.556L649.445 343.517C649.445 343.517 647.014 343.517 647.014 348.379C647.014 353.241 642.76 458.374 642.76 458.374L641.545 498.483L664.637 500.914L673.145 425.558L669.499 375.726L651.268 346.556Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M731.485 328.325L748.501 330.756C755.131 337.699 760.849 345.459 765.517 353.848C772.809 367.218 794.687 392.742 789.825 412.188C784.963 431.635 770.378 466.882 770.378 466.882L747.286 457.159C747.286 457.159 765.517 414.619 764.301 410.973C763.086 407.327 748.501 385.449 748.501 385.449L731.485 328.325Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M657.953 268.162C657.953 268.162 637.291 266.946 650.66 253.577C650.66 253.577 661.599 248.715 666.461 251.146C666.461 251.146 673.753 246.284 673.753 248.715C673.753 248.715 699.277 241.423 702.923 266.946C706.569 292.47 700.492 304.624 700.492 304.624L683.476 303.409C683.476 303.409 687.123 282.747 673.753 285.178C673.753 285.178 662.814 288.824 661.599 285.178C660.383 281.531 657.953 268.162 657.953 268.162Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.2,
    d: "M667.676 499.09L678.615 426.166L671.322 381.195L673.753 430.109L666.461 499.09H667.676Z",
    fill: "black"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepFour);
export default __webpack_public_path__ + "static/media/step_four.5c7ff62f.svg";
export { ForwardRef as ReactComponent };